<template>
  <div>
    <!--<base-header></base-header>-->
    <div class="container">

      <div class="text-center mt10 mb30">
        <img src="/static/ccall.png" class="logo-ccall" width="200" />
      </div>

      <form @submit.prevent="setPassword">
        <div class="form-header">{{$t('register.needSetPassword')}}</div>
        <p>{{$t('register.passwordGuide')}}</p>
        <div class="form-group">
          <input type="password" class="form-control text-center" v-model="password" :placeholder="$t('register.password')" :class="{'form-error': errorMessage['password']}" autocomplete="new-password" />
          <p v-for="msg in errorMessage['password']" class="text-error">{{msg}}</p>
        </div>
        <div class="form-group text-center btn-submit">
          <base-button type="submit" class="btn-block" :disabled="password.length == 0 || isDisabled">{{$t('register.next')}}</base-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import Slide from '../components/Slide';
  import BaseButton from "../components/Button.vue";
  import BaseHeader from "../components/Header.vue";

  export default {
    components: {
      BaseHeader,
      BaseButton,
      Slide,
    },
    name: 'PasswordPage',
    props: {
      phone: String,
      token: String,
    },
    data() {
      return {
        password: '',
        errorMessage: [],
        isDisabled: false,
        event_name: ''
      };
    },
    methods: {
      setPassword() {
        this.isDisabled = true;
        this.errorMessage = [];
        const formData = new FormData();
        formData.append('phone', this.phone);
        formData.append('token', this.token);
        formData.append('password', this.password);
        this.axios.post('/password', formData).then((response) => {
          if ((response.data.status)) {
            window.localStorage.setItem('url', response.data.data.url);
            this.event_name = response.data.data.event_name;
            this.$router.push({name: 'RegisterPage', params: {token: response.data.data.token, event_name: this.event_name}});
          } else {
            this.isDisabled = false;
            this.errorMessage = response.data.data;
          }
        })
      }
    }
  };
</script>
<style scoped="">
  .btn-block {
    width: 80% !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/PasswordPage.vue